import { USER_REQUEST, USER_PROFILE_BKP, USER_SET_PROFILE_CANCEL, USER_SET_PROFILE_SAVE, USER_SET_PROFILE, USER_ERROR, USER_SUCCESS, USER_GET_ALL, USER_DEL_ID } from '../actions/user'
import { AUTH_LOGOUT, AUTH_REQUEST, AUTH_REQUEST_DONE, AUTH_ERROR } from '../actions/auth'
import { MSG_NOT_SHOW, MSG_SHOW } from '../actions/messages'
import Vue from 'vue'
import axios from 'axios'
import lodash from 'lodash'

const state = {
  status: '',
  profile: localStorage.getItem('user-profile') || '',
  allUsers: [],
  profileChange: false,
  profileBkp: ''
}

const getters = {
  getProfile: state => state.profile,
  isProfileLoaded: state => !!state.profile,
  allUsers: state => state.allUsers,
  profileChange: state => state.profileChange
}

const actions = {
  [USER_SET_PROFILE_SAVE]: ({commit, dispatch}) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_REQUEST)

      var tokexx = localStorage.getItem('user-token');
      axios.defaults.headers.common['Authorization'] = tokexx;

      var userIdd = localStorage.getItem('user-id');
      console.log({"userId": userIdd, "profile": state.profile})
      axios.post('https://api.personalizedenglish.com.br/users/updateuserprofile', {"userId": userIdd, "profile": state.profile})

        .then(resp => {
        console.log('resp USER_GET_ALL', resp)
        dispatch(USER_PROFILE_BKP)
        dispatch(AUTH_REQUEST_DONE)
        dispatch(USER_SET_PROFILE_CANCEL)
        resolve(resp)
      })
      .catch(err => {
        commit(AUTH_ERROR, err)
        reject(err)
      })
    })
  },
  [USER_SET_PROFILE_CANCEL]: ({commit, dispatch}) => {
    commit(USER_SET_PROFILE_CANCEL)
  },
  [USER_SET_PROFILE]: ({commit, dispatch},value) => {
    console.log('kind'+value.kind+' data:'+value.data)
    if(state.profileChange===false){
      commit(USER_PROFILE_BKP)
    }
    commit(USER_SET_PROFILE, value)

  },
  [USER_REQUEST]: ({commit, dispatch},userProfile) => {
    console.log('userProfile',userProfile)
    commit(USER_REQUEST)
    // if(!!userProfile.avatar_url){userProfile['avatar_url'] = 'caue'}
    commit(USER_SUCCESS, userProfile)

  },
  [USER_PROFILE_BKP]: ({commit, dispatch}) => {
    commit(USER_PROFILE_BKP)
  },
  [USER_GET_ALL]: ({commit, dispatch}) => {
      return new Promise((resolve, reject) => {
        commit(AUTH_REQUEST)

        var tokexx = localStorage.getItem('user-token');
        axios.defaults.headers.common['Authorization'] = tokexx;

        var userIdd = localStorage.getItem('user-id');

        axios.post('https://api.personalizedenglish.com.br/users/findbyall', {"userId": userIdd})

          .then(resp => {

          console.log('resp USER_GET_ALL', resp.data)
          commit(USER_GET_ALL, resp.data.users)
          dispatch(AUTH_REQUEST_DONE)
          resolve(resp)
        })
        .catch(err => {
          commit(AUTH_ERROR, err)
          reject(err)
        })
      })
    },
}

const mutations = {
  [USER_SET_PROFILE]: (state, value) => {
    state.profileChange = true;
    console.log('mutations say',value)
    if(value.kind==='email'){
      state.profile.email = value.data
      localStorage.setItem('user-profile', state.profile)
    }else if(value.kind==='firstName'){
      state.profile.firstName = value.data
      localStorage.setItem('user-profile', state.profile)
    }else if(value.kind==='lastName'){
      state.profile.lastName = value.data
      localStorage.setItem('user-profile', state.profile)
    }else if(value.kind==='language'){
      state.profile.language = value.data
      localStorage.setItem('user-profile', state.profile)
    }else if(value.kind==='objectives'){
      state.profile.objectives = value.data
      localStorage.setItem('user-profile', state.profile)
    }else if(value.kind==='celular'){
      state.profile.celular = value.data
      localStorage.setItem('user-profile', state.profile)
    }else if(value.kind==='city'){
      state.profile.city = value.data
      localStorage.setItem('user-profile', state.profile)
    }else if(value.kind==='state'){
      state.profile.state = value.data
      localStorage.setItem('user-profile', state.profile)
    }
  },
  [USER_PROFILE_BKP]: (state) => {
    var clone = _.clone(state.profile, true);
    console.log('USER_PROFILE_BKP',clone)
    state.profileBkp = clone
  },
  [USER_SET_PROFILE_CANCEL]: (state) => {
    state.profileChange = false
    var clone = _.clone(state.profileBkp, true);
    console.log('USER_SET_PROFILE_CANCEL',clone)
    state.profile = clone
  },
  [USER_GET_ALL]: (state, users) => {
    state.allUsers = users
  },
  [USER_REQUEST]: (state) => {
    state.status = 'loading'
  },
  [USER_SUCCESS]: (state, profile) => {
    state.status = 'success'
    state.profileChange = false;
    Vue.set(state, 'profile', profile)
    localStorage.setItem('user-profile', profile)
  },
  [USER_ERROR]: (state) => {
    state.status = 'error'
  },
  [AUTH_LOGOUT]: (state) => {
    state.profile = ""
    localStorage.removeItem('user-profile')
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js